export default [
	{
		modulo: 26,
		privilegio: 233,
		routerName: 'abastecimento-aeronave-api',
		routerPath: '/abastecimento-aeronave-api',
		componentName: 'AbastecimentoAeronaveApi',
		componentPath: 'modules/layout/abastecimento/relatorio-abastecimento/lista'
	},
	{
		modulo: 26,
		privilegio: 197,
		routerName: 'relatorio-abastecimento',
		routerPath: '/relatorio-abastecimento',
		componentName: 'RelatorioAbastecimento',
		componentPath: 'modules/layout/abastecimento/relatorio-abastecimento/main'
	},
	{
		modulo: 26,
		privilegio: 232,
		routerName: 'abastecimento-aeronave-via-unidade-armazenamento',
		routerPath: '/abastecimento-aeronave-via-unidade-armazenamento',
		componentName: 'abastecimentoDeAeronaveViaUnidadeDeArmazenamento',
		componentPath: 'modules/layout/abastecimento/abastecimento-aeronave-via-unidade-armazenamento/main'
	},
	{
		modulo: 26,
		privilegio: 232,
		routerName: 'abastecimento-aeronave-via-unidade-armazenamento-cadastro',
		routerPath: '/abastecimento-aeronave-via-unidade-armazenamento/cadastro',
		componentName: 'abastecimentoDeAeronaveViaUnidadeDeArmazenamentoCadastro',
		componentPath: 'modules/layout/abastecimento/abastecimento-aeronave-via-unidade-armazenamento/cadastro'
	},
	{
		modulo: 26,
		privilegio: 232,
		props: true,
		routerName: 'abastecimento-aeronave-via-unidade-armazenamento-editar',
		routerPath: 'abastecimento-aeronave-via-unidade-armazenamento/editar/:id',
		componentName: 'abastecimentoDeAeronaveViaUnidadeDeArmazenamentoCadastro',
		componentPath: 'modules/layout/abastecimento/abastecimento-aeronave-via-unidade-armazenamento/cadastro'
	},
	{
		modulo: 8,
		privilegio: 169,
		routerName: 'movimentacao-combustivel',
		routerPath: '/movimentacao-combustivel',
		componentName: 'MovimentacaoCombustivel',
		componentPath: 'modules/layout/abastecimento/movimentacao-combustivel/main'
	},
	{
		modulo: 8,
		privilegio: 169,
		routerName: 'movimentacao-combustivel-cadastro',
		routerPath: '/movimentacao-combustivel/cadastro',
		componentName: 'MovimentacaoCombustivel',
		componentPath: 'modules/layout/abastecimento/movimentacao-combustivel/form'
	},
	{
		modulo: 8,
		privilegio: 169,
		props: true,
		routerName: 'movimentacao-combustivel-visualizar',
		routerPath: '/movimentacao-combustivel/visualizar/:id',
		componentName: 'MovimentacaoCombustivel',
		componentPath: 'modules/layout/abastecimento/movimentacao-combustivel/form'
	},
	{
		modulo: 8,
		privilegio: 169,
		props: true,
		routerName: 'movimentacao-combustivel-editar',
		routerPath: '/movimentacao-combustivel/editar/:id',
		componentName: 'MovimentacaoCombustivel',
		componentPath: 'modules/layout/abastecimento/movimentacao-combustivel/form'
	}
]
